import { useEffect } from 'react';
import type React from 'react';
import styled from 'styled-components';
import { TextField } from '@mui/material';
import { useState } from 'react';
import { observer } from 'mobx-react';

interface EditableCellTextFieldProps {
  value: string;
  onBlur: React.FocusEventHandler<HTMLInputElement>;
}

export const EditableCellTextField: React.FC<EditableCellTextFieldProps> = observer(({ value, onBlur }) => {
  const [inputValue, setInputValue] = useState(value);
  const [lastValidValue, setLastValidValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>): void => {
    if (e.currentTarget.value.trim() === '') {
      setInputValue(lastValidValue);
    } else {
      onBlur(e);
      setLastValidValue(e.currentTarget.value);
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setInputValue(e.target.value);
  };
  return (
    <CssTextField value={inputValue} variant="standard" onChange={handleChange} onBlur={handleBlur} size="small" />
  );
});

const CssTextField = styled(TextField)({
  input: {
    paddingBottom: 0
  },
  '& .MuiInputBase-root': {
    fontSize: '0.875rem'
  },
  '&': {
    width: '100%'
  },
  '& .MuiInputBase-root:before': {
    borderBottom: 0
  },
  '& .MuiInputBase-root.MuiInput-root.MuiInput-underline:hover:before': {
    borderWidth: 1
  }
});
